// ignore typescrit for the whole file
// @ts-ignore
export const flateArt = `


░░░░▒▒▒░░░░░▒▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░▓▓▓▓▓░░▒▓▓▓▓▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░▒▓▓▓▓░░▒▓▓▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▒░░░▒▓▓▓▓▓▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▓▓▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░
▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▒░░░▒▓▓▓▓▓▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▓▓▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░
▓▓▓▓▓▓▓▓▒▒▒▒▒▒▒▒▒░░░░▒▓▓▓▓▓▓░░░░░░░░░░░▒▒▒▒░░░░░░░░░░░░░░▒▓▓▓▓▓▒░░░░░░░░░░░░░░░▒▒▒░░░░░░░░
▓▓▓▓▓▓▓▓░░░░░░░░░░░░░▒▓▓▓▓▓▓░░░░░▒▒▒▓▓▓▓▓▓▓▓▓▓▓▒▒░░░░░▓▓▓▓▓▓▓▓▓▓▓▓▓▓░░░░░▒▒▓▓▓▓▓▓▓▓▓▓▒▒░░░
▓▓▓▓▓▓▓▓░░░░░░░░░░░░░▒▓▓▓▓▓▓░░░░▒▓▓▓▓▓▓▒▒▒▒▓▓▓▓▓▓▒░░░░▓▓▓▓▓▓▓▓▓▓▓▓▓▓░░░▒▓▓▓▓▓▓▓▒▒▒▓▓▓▓▓▓▒░
▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▒░░░░░▒▓▓▓▓▓▓░░░░▒▒▒▒▒▒▒░░░░▒▓▓▓▓▓▓▒░░░░░▒▓▓▓▓▓▓▒░░░░░░░▓▓▓▓▓▓▒░░░░░▓▓▓▓▓▓▒
▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▒░░░░░▒▓▓▓▓▓▓░░░░░░░░░░▒▒▒▒▒▒▓▓▓▓▓▓▒░░░░░▒▓▓▓▓▓▓▒░░░░░░▒▓▓▓▓▓▓▒▒▒▒▒▒▓▓▓▓▓▓▒
▓▓▓▓▓▓▓▓▒▒▒▒▒▒▒▒░░░░░▒▓▓▓▓▓▓░░░░░▒▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▒░░░░░▒▓▓▓▓▓▓▒░░░░░░▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓
▓▓▓▓▓▓▓▓░░░░░░░░░░░░░▒▓▓▓▓▓▓░░░▒▓▓▓▓▓▓▓▒░░░░▓▓▓▓▓▓▒░░░░░▒▓▓▓▓▓▓▒░░░░░░▒▓▓▓▓▓▓▒░░░░░░░░░░░░
▓▓▓▓▓▓▓▓░░░░░░░░░░░░░▒▓▓▓▓▓▓░░░▒▓▓▓▓▓▓▒░░░░▒▓▓▓▓▓▓▒░░░░░▒▓▓▓▓▓▓▒░░░░░░░▓▓▓▓▓▓▒░░░░░▒▓▓▓▓▓▒
▓▓▓▓▓▓▓▓░░░░░░░░░░░░░▒▓▓▓▓▓▓░░░▒▓▓▓▓▓▓▓▓▒▒▓▓▓▓▓▓▓▓▓▒▒░░░░▓▓▓▓▓▓▓▒▒▒▒░░░░▒▓▓▓▓▓▓▒▒▒▓▓▓▓▓▓▒░
▓▓▓▓▓▓▓▓░░░░░░░░░░░░░▒▓▓▓▓▓▓░░░░▒▒▓▓▓▓▓▓▓▒▒░░▓▓▓▓▓▓▓▓░░░░░▒▓▓▓▓▓▓▓▓▒░░░░░░▒▒▓▓▓▓▓▓▓▓▓▒▒░░░

Don't look at those nasty console errors, appreciate this ASCII art :)  

`;
